import { FC, useEffect, useState } from 'react';
import { getTreaserAni } from '../../util';
import css from './index.module.scss';
import EmailBox from './EmailBox';
import style from './emailBox.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';
import { subscribeFn } from '@/service/common';
import Popup from '@/components/SignUpForm/Popup';

const TreaserB: FC = () => {
    const { useLang, useRouter, Link, gtm } = useGlobal();
    const { t } = useLang('glacierwave.treaser');
    const { locale } = useRouter();
    const [isGlacierHover, setGlacierHover] = useState(false);
    const [isWaveHover, setWaveHover] = useState(false);
    const [checkedObj, setCheckedObj] = useState({ wave2: false, glacier: true });
    const [input, setInput] = useState('');
    const EMERSYS_SITES = ['kr'];
    const [msg, setMsg] = useState('');
    const [popupVisible, setPopupVisible] = useState(false);
    const showPolicyCheck = ['au'].includes(locale);
    // const [productSelections, setProductSelections] = useState<string[]>([]);

    // const changeSelections = (key: string) => {
    //     setProductSelections((prev) => {
    //         const index = prev.indexOf(key);
    //         if (index === -1) {
    //             return [...prev, key];
    //         }
    //         prev.splice(index, 1);
    //         return [...prev];
    //     });
    // };

    const handleInputChange = (e: any) => {
        setInput(e.target.value);
    };

    const handleInputFocus = () => {
        if (msg) setMsg('');
    };

    const handleSubmit = async () => {
        const emailRegex = /^[\w.-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegex.test(input.trim())) {
            return setMsg(t('email_input_error'));
        }

        try {
            const res = await subscribeFn(input.trim(), 'KR_NEW_PRODUCT_WARM_UP');
            if (res?.code === '0') {
                setInput('');
                setPopupVisible(true);
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'activity_submit',
                    button_name: t('email_subscribe'),
                    status: 'success',
                    tag: 'None',
                });
            } else {
                setShowMsg(res?.message);
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'activity_submit',
                    button_name: t('email_subscribe'),
                    status: 'fail',
                    tag: 'None',
                });
            }
        } catch (e) {
            setShowMsg(e);
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_submit',
                button_name: t('email_subscribe'),
                status: 'fail',
                tag: 'None',
            });
        }
    };

    useEffect(() => {
        const treaserAni = getTreaserAni();
        treaserAni?.create({
            syncFromTo: [
                [`.${css.glacierWaveTreaserB} #b-ani-treaser-title`, { opacity: 0.1, ease: 'linear' }, { opacity: 1 }],
                [`.${css.glacierWaveTreaserB} .product-selection`, { opacity: 0.1, ease: 'linear' }, { opacity: 1 }],
            ],
            triggerElement: `.${css.glacierWaveTreaserB}`,
            triggerHook: 1,
            offset: 350,
            duration: 100,
        });
    }, []);

    return (
        <div className={css.glacierWaveTreaserB}>
            <div className="treaser-title" id="b-ani-treaser-title">
                {t('email_title')}
            </div>
            <div className="product-selection">
                <div className="product-item">
                    <div
                        className={`product-img-box ${['au'].includes(locale) ? 'cursor' : ''}`}
                        onMouseEnter={() => setGlacierHover(true)}
                        onMouseLeave={() => setGlacierHover(false)}
                        // onClick={() => changeSelections(PRODUCT_KEY.glacier)}
                        onClick={() => setCheckedObj({ ...checkedObj, glacier: !checkedObj?.glacier })}
                    >
                        {isGlacierHover ? (
                            <NextImage
                                webpSrc={require('@publicLocal/glacier-and-wave-2/pc/glacier-hover.webp')}
                                src={require('@publicLocal/glacier-and-wave-2/pc/glacier-hover.png')}
                            />
                        ) : (
                            <NextImage
                                webpSrc={require('@publicLocal/glacier-and-wave-2/common/glacier-normal.webp')}
                                src={require('@publicLocal/glacier-and-wave-2/common/glacier-normal.png')}
                            />
                        )}
                        {['au'].includes(locale) && <div className={`icon-check ${checkedObj?.glacier ? 'checked' : ''}`}></div>}
                    </div>
                    <div className="product-name">{t('product_glacier')}</div>
                </div>
                <div className="product-item">
                    <div
                        className={`product-img-box ${['au'].includes(locale) ? 'cursor' : ''}`}
                        onMouseEnter={() => setWaveHover(true)}
                        onMouseLeave={() => setWaveHover(false)}
                        // onClick={() => changeSelections(PRODUCT_KEY.waveTwo)}
                        onClick={() => setCheckedObj({ ...checkedObj, wave2: !checkedObj?.wave2 })}
                    >
                        {isWaveHover ? (
                            <NextImage
                                webpSrc={require('@publicLocal/glacier-and-wave-2/pc/wave-two-hover.webp')}
                                src={require('@publicLocal/glacier-and-wave-2/pc/wave-two-hover.png')}
                            />
                        ) : (
                            <NextImage
                                webpSrc={require('@publicLocal/glacier-and-wave-2/common/wave-two-normal.webp')}
                                src={require('@publicLocal/glacier-and-wave-2/common/wave-two-normal.png')}
                            />
                        )}
                        {['au'].includes(locale) && <div className={`icon-check ${checkedObj?.wave2 ? 'checked' : ''}`}></div>}
                    </div>
                    <div className="product-name">{t('product_wave_two')}</div>
                </div>
            </div>
            {!EMERSYS_SITES.includes(locale) && <EmailBox checkedObj={checkedObj} />}
            {EMERSYS_SITES.includes(locale) && (
                <div className="control-box">
                    <div className="email-desc">
                        {t.rich('email_description', {
                            link: (text: string) => (
                                <Link target="_blank" href="https://lin.ee/g7W0VbD" dataLayer={getDataLayer(text)}>
                                    <span className="blue-text">{text}</span>
                                </Link>
                            ),
                            white: (text: string) => <span className="white">{text}</span>,
                            small: (text: string) => <span className="small">{text}</span>,
                        })}
                    </div>
                    <div className="control">
                        <div className="input-box">
                            <input
                                type="text"
                                className="input"
                                value={input}
                                placeholder={t('email_input_placeholder')}
                                onChange={handleInputChange}
                                onFocus={handleInputFocus}
                            />
                            <svg className="email-icon" viewBox="0 0 16 16" fill="currentColor" width="1em" height="1em">
                                <path d="M2.8571429 6.1392045v5.4971591c0 .2510885.191878.4545455.4285714.4545455h9.4285714c.2366935 0 .4285714-.203457.4285714-.4545455V6.125L8.6964286 9.1789773c-.4233715.283907-.9691628.2841869-1.3928572 0L2.857143 6.1392045zM3.2857143 3h9.4285714C13.4243661 3 14 3.6105208 14 4.3636364v7.2727272C14 12.3894792 13.4243661 13 12.7142857 13H3.2857143C2.5756339 13 2 12.3894792 2 11.6363636V4.3636364C2 3.6105208 2.5756339 3 3.2857143 3zm0 .909091c-.2366935 0-.4285714.2036118-.4285714.4545454v.4403409c0 .1521342.0739137.2960635.2008928.3835227l4.7142857 3.2244318c.1364383.0953124.3183687.095219.4553572 0l4.7142857-3.2386363c.1271273-.0810654.2008928-.2248714.2008928-.3835228v-.4261363c0-.2509336-.1918779-.4545455-.4285714-.4545455H3.2857143z"></path>
                            </svg>
                        </div>
                        <button className="subscribe" onClick={handleSubmit}>
                            {t('email_subscribe')}
                        </button>
                    </div>
                    {msg && <p className="error-msg">{msg}</p>}
                </div>
            )}
            {locale === 'jp' && (
                <div className="line-box">
                    <div className="line-img-box">
                        <NextImage
                            webpSrc={require('@publicLocal/glacier-and-wave-2/pc/line-logo.webp')}
                            src={require('@publicLocal/glacier-and-wave-2/pc/line-logo.png')}
                        />
                    </div>
                    <div className="line-img-box">
                        <NextImage
                            webpSrc={require('@publicLocal/glacier-and-wave-2/pc/line-code.webp')}
                            src={require('@publicLocal/glacier-and-wave-2/pc/line-code.png')}
                        />
                    </div>
                </div>
            )}
            <Popup
                className={style.popupModal}
                visible={popupVisible}
                title={t('popup_title')}
                content={showPolicyCheck ? t('popup_text') : ''}
                // content={''}
                buttonText={t('popup_btn')}
                showButton={showPolicyCheck}
                onCancel={() => setPopupVisible(false)}
                btnLink={(() => {
                    const map = {
                        jp: 'https://lin.ee/g7W0VbD',
                        kr: 'https://lin.ee/g7W0VbD',
                        au: 'https://www.facebook.com/groups/efaustralia/',
                    };
                    return map[locale] || '';
                })()}
                theme={'black'}
            />
        </div>
    );
};

export default TreaserB;
